import classnames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import store from '../../../store';

const resetRegistration = () => {
  store.dispatch({ type: 'FINISH_REGISTRATION' });
};

// IGN-2345: read the live location via useLocation so the active indicator
// re-computes on React Router 6 client-side navigation. The previous class
// component read window.location.pathname once and never re-rendered on route
// change, so the selected item's yellow indicator went stale/missing.
const SideMenuItem = ({ title, href, handleOpen }) => {
  const { pathname } = useLocation();
  const selected = pathname === href;

  return (
    <li className={classnames('nav-item', { selected })} onClick={handleOpen}>
      <Link className="title" onClick={resetRegistration} to={href}>
        {title}
      </Link>
    </li>
  );
};

export default SideMenuItem;
